import { ProjectFromAPI } from '../types';
import { transformProjectResponse } from './api-transforms';
import apiRequest from './apiRequest';

export default async function getProject(projectID: string) {
  const { data, error } = await apiRequest<{
    project: ProjectFromAPI;
  }>('mogen-orchestration', `/v2/projects/${projectID}`);

  return {
    data: data ? transformProjectResponse(data.project) : undefined,
    error,
  };
}
